<template>
    <div>
        <el-table
            class="rounded"
            v-loading="loading"
            :data="data"
            align="center"
            border
        >
            <!-- Codigo protheus -->
            <el-table-column label="Cód. Protheus" width="120" align="left">
                <template slot-scope="scope">
                    <span>{{ scope.row.codigo_protheus }}</span>
                </template>
            </el-table-column>

            <!-- Descricao -->
            <el-table-column label="Descrição" min-width="220" align="left">
                <template slot-scope="scope">
                   <span>{{ scope.row.descricao }}</span>
                </template>
            </el-table-column>

            <!-- Criado em -->
            <el-table-column label="Criado em" width="180" align="left">
                <template slot-scope="scope">
                    <div class="d-flex align-items-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-1">{{ formatDate(scope.row.created_at, true) }}</span>
                    </div>
                </template>
            </el-table-column>

            <!-- Criado em -->
            <el-table-column label="Atualizado em" width="180" align="left">
                <template slot-scope="scope">
                    <div class="d-flex align-items-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-1">{{ formatDate(scope.row.updated_at, true) }}</span>
                    </div>
                </template>
            </el-table-column>

            <!-- Acoes -->
            <el-table-column
              fixed="right"
              align="right"
              width="50"
            >
              <div slot="header" style="width: 100%;">
                  <i class="el-icon-menu" />
              </div>

              <template slot-scope="scope">
                    <div class="d-flex justify-content-between">
                        <el-popover placement="bottom-end" trigger="hover">
                            <el-button
                                slot="reference"
                                size="mini" 
                                type="info" 
                                plain 
                                circle
                                :disabled="loading"
                            >
                                <i class="el-icon-more"></i>
                            </el-button>

                            <div :style="{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', gap: '4px', maxWidth: '300px' }">
                                <div :style="{ width: '100%'}">
                                    <el-button
                                        slot="reference"
                                        size="mini"
                                        type="warning"
                                        plain
                                        @click="dispatchPrazoPagamento(scope.row.id)"
                                        :style="{ width: '100%'}"
                                    >   
                                        <i class="el-icon-edit"></i>
                                        <span>Editar</span>
                                    </el-button>
                                </div>
                            </div>
                        </el-popover>
                    </div>
              </template>
            </el-table-column>

            <template slot="empty">
                <el-empty description="Nenhum prazo de pagamento disponível"></el-empty>
            </template>
        </el-table>

        <!-- Paginacao -->
        <el-row class="mt-3">
            <el-col>
                <el-pagination
                  background
                  :current-page.sync="pagination.data.currentPage"
                  :page-sizes="pagination.pageSizes"
                  :page-size="pagination.data.perPage"
                  layout="total, sizes, prev, pager, next"
                  :total="pagination.total"
                  @current-change="handlePageChange"
                  @size-change="handleSizeChange"
                />
            </el-col>
        </el-row>

        <!-- PrazoPagamentoEdit Edit -->
        <PrazoPagamentoEdit ref="prazoPagamentoEdit" @updated="fetch"/>
    </div>
</template>

<script>
    // Components
    import CardBase from "@/components/_macro/CardBase.vue";
    import { Empty, Table, TableColumn, Notification, Popover } from "element-ui";

    import PrazoPagamentoEdit from "./PrazoPagamentoEdit.vue";

    // Api
    import { PrazoPagamentoApi } from "@/api/PrazoPagamentoApi";
    const prazoPagamentoApi = new PrazoPagamentoApi();

    // Utils
    import { formatDate } from "@/util/formatters";

    export default {
        name: "prazo-pagamento-list",
        data() {
            return {
                data: [],
                loading: false,
                filters: {
                    orderBy: 'latest',
                },
                pagination: {
                    data: {
                        currentPage: 1,
                        perPage: 15,
                    },
                    pageSizes: [15, 50, 75, 100],
                    total: 0
                },
            }
        },
        methods: {
            async fetch() {
                try {
                    this.loading = true;

                    const res = await prazoPagamentoApi.list({
                        ...this.filters,
                        ...this.pagination.data
                    });

                    this.data = res.data;
                    this.pagination.total = res.total;
                } catch (err) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter os prazos de pagamento!'
                    });
                } finally {
                    this.loading = false;
                }
            },
            async dispatchPrazoPagamento(prazoPagamentoId) {
                this.$refs.prazoPagamentoEdit.prazoPagamentoId = prazoPagamentoId;

                const elLoading = this.$loading({ lock: true })

                await this.$refs.prazoPagamentoEdit.show();

                elLoading.close();

                return this.$refs.prazoPagamentoEdit.toggleModal();
            },
            /*
            * Pagination 
            *
            */
            handlePageChange(page) {
                this.pagination.data.currentPage = page;
                this.fetch();
            },
            handleSizeChange(val) {
                this.pagination.data.perPage = val;
                this.pagination.data.currentPage = 1;
                this.fetch();
            },
            formatDate
        },
        watch: {
            "filters": {
                handler(_newValue) {
                    this.fetch(_newValue);
                },
                deep: true,
            }
        },
        mounted() {
            this.fetch();
        },
        components: {
            CardBase,
            PrazoPagamentoEdit,
            [Empty.name]: Empty,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Notification.name]: Notification
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/_macro/prazo_pagamento/PrazoPagamentoList.vue